export enum Status {
  open = "open",
  closed = "closed",
  notSet = "notSet",
}
